import { Clock, Users, Phone, Headphones } from 'lucide-react';
interface MobileWhySectionProps {
  compact?: boolean;
}
const MobileWhySection = ({
  compact = false
}: MobileWhySectionProps) => {
  const benefits = [{
    icon: Clock,
    title: 'Skip the Lines',
    description: 'Get priority onboarding and personalized setup without the retail store hassle.',
    color: 'from-pink-500 to-purple-600'
  }, {
    icon: Users,
    title: 'Business Plans Only',
    description: 'No retail runaround — we focus exclusively on business wireless solutions.',
    color: 'from-purple-500 to-blue-600'
  }, {
    icon: Phone,
    title: 'Expert Consultation',
    description: 'Match your team with the right T-Mobile plan for voice, data, or bundled services.',
    color: 'from-blue-500 to-cyan-600'
  }, {
    icon: Headphones,
    title: 'Direct Support',
    description: 'Direct contact with our support team for comprehensive after-sales help.',
    color: 'from-cyan-500 to-pink-600'
  }];
  if (compact) {
    return <div className="mt-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {benefits.map((benefit, index) => <div key={benefit.title} className="text-center group transform hover:scale-105 transition-all duration-300 animate-fade-in bg-white/80 backdrop-blur-sm rounded-xl p-6 shadow-lg hover:shadow-xl" style={{
          animationDelay: `${0.1 * (index + 1)}s`
        }}>
              <div className={`w-16 h-16 bg-gradient-to-r ${benefit.color} rounded-2xl flex items-center justify-center mx-auto mb-4 group-hover:rotate-6 transition-all duration-300 shadow-lg group-hover:shadow-xl`}>
                <benefit.icon className="h-8 w-8 text-white" />
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2 group-hover:text-pink-600 transition-colors duration-300">
                {benefit.title}
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                {benefit.description}
              </p>
            </div>)}
        </div>
      </div>;
  }
  return <section className="py-20 bg-gradient-to-br from-white via-purple-50 to-pink-50 relative overflow-hidden">
      {/* Background Animation */}
      <div className="absolute inset-0 opacity-20">
        {[...Array(6)].map((_, i) => <div key={i} className="absolute rounded-full bg-gradient-to-r from-pink-200 to-purple-200 animate-bounce" style={{
        width: `${100 + i * 50}px`,
        height: `${100 + i * 50}px`,
        left: `${Math.random() * 100}%`,
        top: `${Math.random() * 100}%`,
        animationDelay: `${i * 0.5}s`,
        animationDuration: `${8 + i * 2}s`
      }} />)}
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4 animate-fade-in">
            Why Work With Us?
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto animate-fade-in" style={{
          animationDelay: '0.2s'
        }}>
            Experience the difference of working with a T-Mobile Authorized Partner focused on business solutions.
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {benefits.map((benefit, index) => <div key={benefit.title} className="text-center group transform hover:scale-105 transition-all duration-300 animate-fade-in" style={{
          animationDelay: `${0.1 * (index + 1)}s`
        }}>
              <div className={`w-20 h-20 bg-gradient-to-r ${benefit.color} rounded-2xl flex items-center justify-center mx-auto mb-6 group-hover:rotate-6 transition-all duration-300 shadow-lg group-hover:shadow-xl`}>
                <benefit.icon className="h-10 w-10 text-white" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-pink-600 transition-colors duration-300">
                {benefit.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {benefit.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
};
export default MobileWhySection;
